import { render } from "./CategorySelect.vue?vue&type=template&id=9cfdc470&scoped=true&ts=true"
import script from "./CategorySelect.vue?vue&type=script&lang=ts"
export * from "./CategorySelect.vue?vue&type=script&lang=ts"

import "./CategorySelect.vue?vue&type=style&index=0&id=9cfdc470&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cfdc470"]])

export default __exports__